/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthorizedEntity
 */
export interface AuthorizedEntity {
    /**
     * 
     * @type {string}
     * @memberof AuthorizedEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedEntity
     */
    idType?: AuthorizedEntityIdTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof AuthorizedEntity
     */
    expireDate?: Date;
}

/**
* @export
* @enum {string}
*/
export enum AuthorizedEntityIdTypeEnum {
    CareProvider = 'CareProvider',
    System = 'System'
}

export function AuthorizedEntityFromJSON(json: any): AuthorizedEntity {
    return AuthorizedEntityFromJSONTyped(json, false);
}

export function AuthorizedEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthorizedEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'idType': !exists(json, 'idType') ? undefined : json['idType'],
        'expireDate': !exists(json, 'expireDate') ? undefined : (new Date(json['expireDate'])),
    };
}

export function AuthorizedEntityToJSON(value?: AuthorizedEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
        'idType': value.idType,
        'expireDate': value.expireDate === undefined ? undefined : (value.expireDate.toISOString()),
    };
}

